<template>
  <div>
    <div class="ui form" v-if="part == 1">
      <div class="ui field">
        <label>Current Investments</label>
        <currency-input
          v-model.number="activePlan.accounts[0].accountMarketValue"
          :currency="activePlan.goalInfo.currency"
        />
      </div>
      <div class="ui field">
        <label
          >Monthly income required (gross)
          <small
            >{{
              formatNr(
                (activePlan.getIncomeCashFlowRequest.income * 12) /
                  activePlan.accounts[0].accountMarketValue,
                "0,0.0%"
              )
            }}
            pa</small
          ></label
        >
        <currency-input
          v-model.number="activePlan.getIncomeCashFlowRequest.income"
          :currency="activePlan.goalInfo.currency"
        />
      </div>

      <div class="ui message">
        <small>all these figures can be changed later</small>
      </div>
    </div>

    <div class="ui" v-if="part == 2">
      <h2>
        Risk Tolerance
        <span class="ui sub header">How willing are you to accept risk?</span>
      </h2>
      <br />

      <div class="ui field">
        <label>Risk Return Trade off?</label>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";
import { getGoalTypes } from "@/gateway.js";
export default {
  name: "GoalTypes",
  components: { vSelect, VueSlider },
  props: ["activePlan"],
  data() {
    return { part: 1 };
  },
  computed: {},
  methods: {
    formatNr(val, fmt) {
      return numeral(val).format(fmt);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
